module.exports = __webpack_public_path__ + "img/user-avatar.b3e70887.svg";